// src/components/ProtectedRoute.jsx
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children, allowedRoles }) => {
  // const user = JSON.parse(localStorage.getItem("user"));
  const user = JSON.parse(localStorage.getItem("user") || "null") || null;
  let redirectTo = null;

  if (!user) {
    redirectTo = "/SignIn";
  } else if (allowedRoles) {
    const userRole = (user.role || "").toLowerCase();
    const normalizedRoles = allowedRoles.map((r) => r.toLowerCase());

    if (!normalizedRoles.includes(userRole)) {
      redirectTo = "/Dashboard";
    }
  }

  // ✅ fire toast only when redirecting
  useEffect(() => {
    if (redirectTo === "/Dashboard") {
      toast.error(" Access denied: You do not have permission.");
    }
    if (redirectTo === "/SignIn") {
      toast.error(" Please log in first.");
    }
  }, [redirectTo]);

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
